"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _divider.default;
  }
});

var _divider = _interopRequireDefault(require("./divider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }